import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class Button extends PureComponent {

  render() {
    const {onClick, children, className, sizeName, bgCss, type, disabled} = this.props

    const sizeCSS = sizeName === 'sm' ? 'py-2 px-4 text-md' : 'py-2 px-4 sm:py-4 sm:px-8 text-lg'
    const css = [
      sizeCSS,
      (bgCss || 'bg-sky'), 
      className,
      disabled && 'opacity-50 cursor-not-allowed',
      'font-bold text-white italic rounded-full uppercase leading-normal tracking-wide focus:outline-none'
    ].join(' ')

    return (
      // eslint-disable-next-line react/button-has-type
      <button
        type={type}
        className={css}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    )
  }
}

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.element,
  className: PropTypes.string,
  sizeName: PropTypes.string,
  bgCss: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool
}

Button.defaultProps = {
  onClick: () => {},
  children: null,
  className: "",
  sizeName: "",
  bgCss: "",
  type: "submit",
  disabled: false
}

export default Button
